export const fieldsWithoutDefaultValue = ['standardRate'];
